import useYotpoInit from '@root/src/hooks/useYotpoInit';

type Props = {
  count: number;
  mode: string;
};
const YotpoReviewsCarousel = ({ count, mode }: Props) => {
  useYotpoInit();

  return (
    <div
      className="yotpo yotpo-reviews-carousel"
      data-background-color="transparent"
      data-type="site"
      data-show-bottomline="1"
      data-autoplay-enabled="1"
      data-autoplay-speed="3000"
      data-show-navigation="1"
      data-count={count}
      data-mode={mode}
      suppressHydrationWarning
    ></div>
  );
};

export default YotpoReviewsCarousel;
